import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../../layouts/layout'
// import Hero from '../components/hero'

const MonsterTrainingPage = ({ data }) => {
  return (
    <Layout>
      <Helmet
        title={'Monster Training | ' + data.siteTitle.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Monster Training overriding description but not keywords.' }
        ]}
      />
      <div style={{margin: '90px auto', maxWidth: '92%'}}>
        <h1>Monster Training</h1>
        <p>Welcome to the monster-training page.</p>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    siteTitle: site {
      siteMetadata {
        title
      }
    }
  }
`

export default MonsterTrainingPage
